<template>
  <v-dialog v-model="dialog" max-width="700">
    <template v-slot:activator="{ on, attrs }">
      <v-list-item v-on="on" v-bind="attrs">
        <v-list-item-title>Cancelar solicitação</v-list-item-title>
      </v-list-item>
    </template>
    <v-card>
      <v-card-title class="green lighten-4 primary--text font-weight-bold"
        >Cancelar Solicitação</v-card-title
      >
      <v-card-text class="pt-5">
        <v-textarea
          label="Motivo cancelamento"
          rows="4"
          v-model="motivo"
        ></v-textarea>
        <v-btn
          block
          rounded
          color="success"
          @click="confirmarCancelamento()"
          :loading="cancelando"
          >Confirmar cancelamento</v-btn
        >
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text rounded @click="dialog = false">Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import { mapActions } from 'vuex';
export default {
    props:{
        solic: Object
    },
  data: () => ({
    dialog: false,
    motivo: "",
    cancelando: false,
  }),
  methods: {
    ...mapActions("atualizacaoCadastral",["getSolicitacoes"]),
    async confirmarCancelamento() {
      var qtdCarac = 10;
      if (this.motivo.trim().length < qtdCarac) {
        this.$toasted.error(
          `Informe um motivo para o cancelamento de no mínimo ${qtdCarac} caracteres`
        );
        return;
      }

      this.cancelando = true;
      await axios
        .post(
          "/colaborador/atestados",
          JSON.stringify({ motivo: this.motivo }),
          {
            params: {
              funcao: "CANCELAR",
              codigo: this.solic.codigo
            },
          }
        )
        .then(async (res) => {
          if (res.data.success) {
            this.$toasted.success("Solicitação cancelada com sucesso!")
            this.dialog = false
            await this.getSolicitacoes()
          } else this.$toasted.error(res.data.msg);
        })
        .catch((e) => this.$toasted.error(e))
        .finally(() => {
          this.cancelando = false;
        });
    },
  },
};
</script>

<style>
</style>